var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1732 8.35658C13.0149 8.35658 12.8566 8.29824 12.7316 8.17324L10.2316 5.67324L7.73158 8.17324C7.48991 8.41491 7.08991 8.41491 6.84824 8.17324C6.60658 7.93158 6.60658 7.53157 6.84824 7.28991L9.78991 4.34824C10.0316 4.10658 10.4316 4.10658 10.6732 4.34824L13.6149 7.28991C13.8566 7.53157 13.8566 7.93158 13.6149 8.17324C13.4899 8.29824 13.3316 8.35658 13.1732 8.35658Z",
    fill: "#8F98A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2316 15.88C10.0732 15.88 9.91491 15.8217 9.78991 15.6967L6.84824 12.755C6.60658 12.5133 6.60658 12.1133 6.84824 11.8717C7.08991 11.63 7.48991 11.63 7.73158 11.8717L10.2316 14.3717L12.7316 11.8717C12.9732 11.63 13.3732 11.63 13.6149 11.8717C13.8566 12.1133 13.8566 12.5133 13.6149 12.755L10.6732 15.6967C10.5482 15.8217 10.3899 15.88 10.2316 15.88Z",
    fill: "#8F98A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDown);
export default __webpack_public_path__ + "static/media/arrow-up-down.3278c52738dcd1794052c6b474964839.svg";
export { ForwardRef as ReactComponent };